import axios from 'axios';
import { WarehouseEntity } from './entities/warehouse.entity';

export default class WarehouseApiService {
  // eslint-disable-next-line class-methods-use-this
  public fetchWarehouses(): Promise<WarehouseEntity[]> {
    return axios.get(
      `${process.env.REACT_APP_TRAVOLTA_URL}/warehouses`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ).then(({ data }) => data);
  }
}
